import './assets/css/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.css';
import {createApp} from 'vue';
import App from './App.vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

const app = createApp(App);
app.component('Swiper', Swiper);
app.component('SwiperSlide', SwiperSlide);
app.use(ElementPlus);
app.mount('#app');
